export default class InteractiveCatalogPageItem {

    constructor() {
        this.itemId = 0;
        this.itemName = '';

        this.left = 0;
        this.top = 0;
        this.width = 0;
        this.height = 0;

        this.hidden = false;
        this.draggable = false;
        this.clonable = false;

        this.deviceLanguages = [];
        this.deviceTypes = [];
    }

}
